import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import _toConsumableArray from "/home/jenkins/workspace/procure-web-seven-test/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray";
import _defineProperty from "/home/jenkins/workspace/procure-web-seven-test/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var modulesFiles = require.context('./', true, /Router.js$/);
var routers = modulesFiles.keys().reduce(function (routers, modulePath) {
  var value = modulesFiles(modulePath);
  var router = value.default;
  if (router && router.length > 0) {
    routers = router.concat(routers);
  }
  return routers;
}, []);

//激活的菜单
export var activeMenus = modulesFiles.keys().reduce(function (activeMenus, modulePath) {
  var value = modulesFiles(modulePath);
  var activeMenu = value.activeMenu;
  if (activeMenu) {
    activeMenus = _objectSpread({}, activeMenu, {}, activeMenus);
  }
  return activeMenus;
}, []);

/**
 * 封装懒加载
 * @type {{resolve(*): *, show()}}
 */
var spinRoute = {
  show: function show() {//加载中显示loading组件
    // let opt = {body: true, text: '页面加载中...', background: 'rgba(0, 0, 0, 0.7)'};
    // if (!unique) {
    //   unique = Loading.service(opt);
    // }
  },
  resolve: function resolve(_resolve) {
    //加载完成隐藏loading组件
    return function (component) {
      _resolve(component);
    };
  }
};
import Vue from 'vue';
import VueRouter from "vue-router";
//登陆
import loginApp from '@/components/login/loginApp';
import singleAuthentication from '@/components/login/singleAuthentication';
import wzSingleAuthentication from '@/components/login/wz/singleAuthentication';
//主页
import mainApp from "@/components/main/mainApp";
Vue.use(VueRouter);
// const mainApp = resolve => {
//   spinRoute.show();
//   require(['../components/main/mainApp'],
//     spinRoute.resolve(resolve))
// }
// import personalCenter from '@/components/main/personalCenter';
var personalCenter = function personalCenter(resolve) {
  spinRoute.show();
  require(['@/components/main/personalCenter'], spinRoute.resolve(resolve));
};
//推送消息通知
var messageInfo = function messageInfo(resolve) {
  spinRoute.show();
  require(['@/components/main/messageInfo'], spinRoute.resolve(resolve));
};
//推送待办事项
var todoList = function todoList(resolve) {
  spinRoute.show();
  require(['@/components/main/todoList'], spinRoute.resolve(resolve));
};
// import personalSafe from '@/components/main/personalSafe';
var personalSafe = function personalSafe(resolve) {
  spinRoute.show();
  require(['@/components/main/personalSafe'], spinRoute.resolve(resolve));
};
// import waiting from "@/components/common/waiting"
var waiting = function waiting(resolve) {
  spinRoute.show();
  require(['@/components/common/waiting'], spinRoute.resolve(resolve));
};
// import errorSession from '@/components/common/errorSession'
var errorSession = function errorSession(resolve) {
  spinRoute.show();
  require(['@/components/common/errorSession'], spinRoute.resolve(resolve));
};
//基础资料
// import dataScreening from "@/components/dataScreening/dataScreening"
var dataScreening = function dataScreening(resolve) {
  spinRoute.show();
  require(['@/components/dataScreening/dataScreeningv2'], spinRoute.resolve(resolve));
};
var internationalDataScreening = function internationalDataScreening(resolve) {
  spinRoute.show();
  require(['@/components/dataScreening/international/dataScreening'], spinRoute.resolve(resolve));
};
// import basicData from "@/components/basicData/basicData"
var basicData = function basicData(resolve) {
  spinRoute.show();
  require(['@/components/basicData/basicData'], spinRoute.resolve(resolve));
};
// import permissionManagement from "@/components/basicData/subModule/permissionManagement/permissionManagement"
var permissionManagement = function permissionManagement(resolve) {
  spinRoute.show();
  require(['@/components/basicData/subModule/permissionManagement/permissionManagement'], spinRoute.resolve(resolve));
};
// import employeeList from "@/components/basicData/subModule/employeeManagement/employeeList"
var employeeList = function employeeList(resolve) {
  spinRoute.show();
  require(['@/components/basicData/subModule/employeeManagement/employeeList'], spinRoute.resolve(resolve));
};
var employeeListDetails = function employeeListDetails(resolve) {
  spinRoute.show();
  require(['@/components/basicData/subModule/employeeManagement/employeeListDetails'], spinRoute.resolve(resolve));
};
// import employeeListAdd from "@/components/basicData/subModule/employeeManagement/employeeListAdd"
var employeeListAdd = function employeeListAdd(resolve) {
  spinRoute.show();
  require(["@/components/basicData/subModule/employeeManagement/employeeListAdd"], spinRoute.resolve(resolve));
};
// import employeeDetails from "@/components/basicData/subModule/employeeManagement/employeeDetails"
var employeeDetails = function employeeDetails(resolve) {
  spinRoute.show();
  require(["@/components/basicData/subModule/employeeManagement/employeeDetails"], spinRoute.resolve(resolve));
};
// import deptList from "@/components/basicData/subModule/deptList/deptList"
var deptList = function deptList(resolve) {
  spinRoute.show();
  require(["@/components/basicData/subModule/deptList/deptList"], spinRoute.resolve(resolve));
};
// import deptAdd from "@/components/basicData/subModule/deptList/deptAdd"
var deptAdd = function deptAdd(resolve) {
  spinRoute.show();
  require(["@/components/basicData/subModule/deptList/deptAdd"], spinRoute.resolve(resolve));
};
// import deptDetails from "@/components/basicData/subModule/deptList/deptDetails"
var deptDetails = function deptDetails(resolve) {
  spinRoute.show();
  require(["@/components/basicData/subModule/deptList/deptDetails"], spinRoute.resolve(resolve));
};
// import treeDeptList from "@/components/basicData/subModule/deptManagement/treeDeptList";
var treeDeptList = function treeDeptList(resolve) {
  spinRoute.show();
  require(["@/components/basicData/subModule/deptManagement/treeDeptList"], spinRoute.resolve(resolve));
};
var treeDeptDetails = function treeDeptDetails(resolve) {
  spinRoute.show();
  require(["@/components/basicData/subModule/deptManagement/treeDeptDetails"], spinRoute.resolve(resolve));
};
// import roleList from "@/components/basicData/subModule/roleManagement/roleList"
var roleList = function roleList(resolve) {
  spinRoute.show();
  require(["@/components/basicData/subModule/roleManagement/roleList"], spinRoute.resolve(resolve));
};
// import roleDetails from "@/components/basicData/subModule/roleManagement/roleDetails"
var roleDetails = function roleDetails(resolve) {
  spinRoute.show();
  require(["@/components/basicData/subModule/roleManagement/roleDetails"], spinRoute.resolve(resolve));
};
// import roleListAdd from "@/components/basicData/subModule/roleManagement/roleListAdd"
var roleListAdd = function roleListAdd(resolve) {
  spinRoute.show();
  require(["@/components/basicData/subModule/roleManagement/roleListAdd"], spinRoute.resolve(resolve));
};
var auditEmpList = function auditEmpList(resolve) {
  spinRoute.show();
  require(["@/components/basicData/subModule/auditEmpManagement/auditEmpList"], spinRoute.resolve(resolve));
};
// import departmentAdd from "@/components/basicData/subModule/departmentAdd/departmentAdd"
//合同
// import contractEntry from "@/components/contract/subModule/contractEntry";
var contractEntry = function contractEntry(resolve) {
  spinRoute.show();
  require(["@/components/contract/subModule/contractEntry"], spinRoute.resolve(resolve));
};
var contractListDetails = function contractListDetails(resolve) {
  spinRoute.show();
  require(["@/components/contract/subModule/contractList/contractListDetails"], spinRoute.resolve(resolve));
};
var contractList = function contractList(resolve) {
  spinRoute.show();
  require(["@/components/contract/subModule/contractList/contractList"], spinRoute.resolve(resolve));
};
var contractDoneDetails = function contractDoneDetails(resolve) {
  spinRoute.show();
  require(["@/components/contract/subModule/contractDoneDetails"], spinRoute.resolve(resolve));
};
var contractReport = function contractReport(resolve) {
  spinRoute.show();
  require(["@/components/contract/subModule/contractReport"], spinRoute.resolve(resolve));
};
var contractChangeDetails = function contractChangeDetails(resolve) {
  spinRoute.show();
  require(["@/components/contract/subModule/contractChange/contractChangeDetails"], spinRoute.resolve(resolve));
};
var contractDone = function contractDone(resolve) {
  spinRoute.show();
  require(["@/components/contract/subModule/contractDone"], spinRoute.resolve(resolve));
};
var contractChangeList = function contractChangeList(resolve) {
  spinRoute.show();
  require(["@/components/contract/subModule/contractChange/contractChangeList"], spinRoute.resolve(resolve));
};
var contractActivationList = function contractActivationList(resolve) {
  spinRoute.show();
  require(["@/components/contract/subModule/contractActivation/contractActivationList"], spinRoute.resolve(resolve));
};
var contractActivationDetails = function contractActivationDetails(resolve) {
  spinRoute.show();
  require(["@/components/contract/subModule/contractActivation/contractActivationDetails"], spinRoute.resolve(resolve));
};

//订单
// import order from "@/components/order/order";
var orderList = function orderList(resolve) {
  spinRoute.show();
  require(["@/components/order/subModule/orderList"], spinRoute.resolve(resolve));
};
// import orderDetails from "@/components/order/orderDetails";
var orderDetails = function orderDetails(resolve) {
  spinRoute.show();
  require(["@/components/order/subModule/orderDetails"], spinRoute.resolve(resolve));
};
// import completed from "@/components/order/subModule/completed";
var completedList = function completedList(resolve) {
  spinRoute.show();
  require(["@/components/order/subModule/completedList"], spinRoute.resolve(resolve));
};
// import submitOrder from "@/components/order/subModule/submitOrder";
var submitOrder = function submitOrder(resolve) {
  spinRoute.show();
  require(["@/components/order/subModule/submitOrder"], spinRoute.resolve(resolve));
};
var myOrderAuditList = function myOrderAuditList(resolve) {
  spinRoute.show();
  require(["@/components/order/subModule/myOrder/myOrderAuditList"], spinRoute.resolve(resolve));
};
var myOrderAuditDetails = function myOrderAuditDetails(resolve) {
  spinRoute.show();
  require(["@/components/order/subModule/myOrder/myOrderAuditDetails"], spinRoute.resolve(resolve));
};
var completedDetails = function completedDetails(resolve) {
  spinRoute.show();
  require(["@/components/order/subModule/completedDetails"], spinRoute.resolve(resolve));
};

//结算
// import settle from "@/components/settle/settle";
//const settle = resolve => {spinRoute.show();require(["@/components/settle/settle"], spinRoute.resolve(resolve))}
// import createSettle from "@/components/settle/subModule/createSettle";
var settleList = function settleList(resolve) {
  spinRoute.show();
  require(["@/components/settle/subModule/settleList"], spinRoute.resolve(resolve));
};
var settlementForm = function settlementForm(resolve) {
  spinRoute.show();
  require(["@/components/settle/subModule/settlementForm"], spinRoute.resolve(resolve));
};
var settlementAccount = function settlementAccount(resolve) {
  spinRoute.show();
  require(["@/components/settle/subModule/settlementAccount"], spinRoute.resolve(resolve));
};
var confirmation = function confirmation(resolve) {
  spinRoute.show();
  require(["@/components/settle/subModule/confirmation/confirmation"], spinRoute.resolve(resolve));
};
//移动设备签认表
var moveForm = function moveForm(resolve) {
  spinRoute.show();
  require(["@/components/settle/subModule/confirmation/moveForm"], spinRoute.resolve(resolve));
};
//移动设备签认表
var moveFormDetail = function moveFormDetail(resolve) {
  spinRoute.show();
  require(["@/components/settle/subModule/confirmation/moveFormDetail"], spinRoute.resolve(resolve));
};
//固定设备签认表
var fixedForm = function fixedForm(resolve) {
  spinRoute.show();
  require(["@/components/settle/subModule/confirmation/fixedForm"], spinRoute.resolve(resolve));
};
//固定设备签认表详情
var fixedFormDetail = function fixedFormDetail(resolve) {
  spinRoute.show();
  require(["@/components/settle/subModule/confirmation/fixedFormDetail"], spinRoute.resolve(resolve));
};
//明细表列表
var detailsForList = function detailsForList(resolve) {
  spinRoute.show();
  require(["@/components/settle/subModule/detailsForList/detailsForList"], spinRoute.resolve(resolve));
};
//明细表列表编制
var detailsForListCreate = function detailsForListCreate(resolve) {
  spinRoute.show();
  require(["@/components/settle/subModule/detailsForList/detailsForListCreate"], spinRoute.resolve(resolve));
};
//明细表列表详情
var detailsForListDetail = function detailsForListDetail(resolve) {
  spinRoute.show();
  require(["@/components/settle/subModule/detailsForList/detailsForListDetail"], spinRoute.resolve(resolve));
};
//汇总表列表编制
var summaryCreate = function summaryCreate(resolve) {
  spinRoute.show();
  require(["@/components/settle/subModule/summary/summaryCreate"], spinRoute.resolve(resolve));
};
//汇总表列表详情
var summaryDetail = function summaryDetail(resolve) {
  spinRoute.show();
  require(["@/components/settle/subModule/summary/summaryDetail"], spinRoute.resolve(resolve));
};
//汇总表列表列表
var summary = function summary(resolve) {
  spinRoute.show();
  require(["@/components/settle/subModule/summary/summary"], spinRoute.resolve(resolve));
};
//线下机械使用现场确认单列表
var machinery = function machinery(resolve) {
  spinRoute.show();
  require(["@/components/audit/machinery/machinery"], spinRoute.resolve(resolve));
};
//线下机械使用现场确认单详情
var machineryDetail = function machineryDetail(resolve) {
  spinRoute.show();
  require(["@/components/audit/machinery/machineryDetail"], spinRoute.resolve(resolve));
};
//编制确认单
var creatConfirmation = function creatConfirmation(resolve) {
  spinRoute.show();
  require(["@/components/audit/machinery/creatConfirmation"], spinRoute.resolve(resolve));
};
// import settleDetails from "@/components/settle/subModule/settleDetails";
var settleDetails = function settleDetails(resolve) {
  spinRoute.show();
  require(["@/components/settle/subModule/settleDetails"], spinRoute.resolve(resolve));
};
// import quantitativeSettle from "@/components/settle/subModule/quantitativeSettle";
var quantitativeSettle = function quantitativeSettle(resolve) {
  spinRoute.show();
  require(["@/components/settle/subModule/quantitativeSettle"], spinRoute.resolve(resolve));
};
// 工单列表
var workOrderList = function workOrderList(resolve) {
  spinRoute.show();
  require(["@/components/settle/workOrderList/workOrderList"], spinRoute.resolve(resolve));
};
var workOrderDetails = function workOrderDetails(resolve) {
  spinRoute.show();
  require(["@/components/settle/workOrderList/workOrderDetails"], spinRoute.resolve(resolve));
};
var settleContractList = function settleContractList(resolve) {
  spinRoute.show();
  require(["@/components/settle/workOrderList/settleContractList"], spinRoute.resolve(resolve));
};
var contractWorkOrderList = function contractWorkOrderList(resolve) {
  spinRoute.show();
  require(["@/components/settle/workOrderList/contractWorkOrderList"], spinRoute.resolve(resolve));
};
//设备
// import vehicleMap from "@/components/vehicle/vehicleMap";
var vehicleMainDetailMap = function vehicleMainDetailMap(resolve) {
  spinRoute.show();
  require(["@/components/vehicle/vehicleMainDetailMap"], spinRoute.resolve(resolve));
};
var vehicleMap = function vehicleMap(resolve) {
  spinRoute.show();
  require(["@/components/vehicle/vehicleMap"], spinRoute.resolve(resolve));
};
// import vehicleList from "@/components/vehicle/subModule/vehicleList";
var vehicleList = function vehicleList(resolve) {
  spinRoute.show();
  require(["@/components/vehicle/subModule/vehicleList"], spinRoute.resolve(resolve));
};
// import vehicleDetailsForVehicle from "@/components/vehicle/subModule/vehicleDetailsForVehicle";
var vehicleDetailsForVehicle = function vehicleDetailsForVehicle(resolve) {
  spinRoute.show();
  require(["@/components/vehicle/subModule/vehicleDetailsForVehicle"], spinRoute.resolve(resolve));
};

//专家库管理
var experts = function experts(resolve) {
  spinRoute.show();
  require(["@/components/expertBaseManagement/experts.vue"], spinRoute.resolve(resolve));
};

//资格审查
var examination = function examination(resolve) {
  spinRoute.show();
  require(["@/components/qualifiedSupplierManagement/examination/examination"], spinRoute.resolve(resolve));
};
//资格审查详情
// import examinationDetail from "@/components/bidding/examination/examinationDetail"
var examinationDetail = function examinationDetail(resolve) {
  spinRoute.show();
  require(["@/components/qualifiedSupplierManagement/examination/examinationDetail"], spinRoute.resolve(resolve));
};
var blackmailAudit = function blackmailAudit(resolve) {
  spinRoute.show();
  require(["@/components/qualifiedSupplierManagement/blackmailAudit/index"], spinRoute.resolve(resolve));
};
var blackmailAuditList = function blackmailAuditList(resolve) {
  spinRoute.show();
  require(["@/components/qualifiedSupplierManagement/blackmailAudit/list"], spinRoute.resolve(resolve));
};
//设备出租单位
var supplier = function supplier(resolve) {
  require(["@/components/qualifiedSupplierManagement/supplier/supplier"], spinRoute.resolve(resolve));
};
var qualifiedSuppliersDetails = function qualifiedSuppliersDetails(resolve) {
  spinRoute.show();
  require(["@/components/qualifiedSupplierManagement/supplier/qualifiedSuppliersDetails"], spinRoute.resolve(resolve));
};
//询比价立项
var buildBidding = function buildBidding(resolve) {
  spinRoute.show();
  require(["@/components/bidding/buildBidding/buildBidding"], spinRoute.resolve(resolve));
};
//待重新立项
var reBuildBidding = function reBuildBidding(resolve) {
  spinRoute.show();
  require(["@/components/bidding/buildBidding/reBuildBidding"], spinRoute.resolve(resolve));
};
//修改标书
// import updateBidding from "@/components/bidding/updateBidding/updateBidding";
var updateBidding = function updateBidding(resolve) {
  spinRoute.show();
  require(["@/components/bidding/updateBidding/updateBidding"], spinRoute.resolve(resolve));
};
//修改标书详情
// import updateBiddingDetail from "@/components/bidding/updateBidding/updateBiddingDetail";
//旧版本租赁评审
/* const updateBiddingDetail = resolve => {
  spinRoute.show();
  require(
    ["@/components/bidding/updateBidding/updateBiddingDetail"],
    spinRoute.resolve(resolve))
} */
//新版本租赁评审
var updateBiddingDetail = function updateBiddingDetail(resolve) {
  spinRoute.show();
  require(["@/views/bidManageNew/bidFilesListNew/detail"], spinRoute.resolve(resolve));
};

//租赁报表
var bidReport = function bidReport(resolve) {
  spinRoute.show();
  require(["@/components/bidding/bidReport"], spinRoute.resolve(resolve));
};

//车辆首页
var carManagement = function carManagement(resolve) {
  spinRoute.show();
  require(["@/components/carManagement/main/carManagement"], spinRoute.resolve(resolve));
};

//设备联网首页
var vehicleNetApp = function vehicleNetApp(resolve) {
  spinRoute.show();
  require(["@/components/vehicleNetApp/main/vehicleNetApp"], spinRoute.resolve(resolve));
};

//租赁管理首页
var bidModel = function bidModel(resolve) {
  spinRoute.show();
  require(["@/components/bidding/main/bidModel"], spinRoute.resolve(resolve));
};
//统计
var orderStatistics = function orderStatistics(resolve) {
  spinRoute.show();
  require(["@/components/statistics/orderStatistics/orderStatistics"], spinRoute.resolve(resolve));
};
var orderStatisticsDetails = function orderStatisticsDetails(resolve) {
  spinRoute.show();
  require(["@/components/statistics/orderStatistics/orderStatisticsDetails"], spinRoute.resolve(resolve));
};
//设备类型
var vehicleTypeList = function vehicleTypeList(resolve) {
  spinRoute.show();
  require(['@/components/basicData/subModule/vehicleTypeManagement/vehicleTypeList'], spinRoute.resolve(resolve));
};
// const vehicleTypeDetails = resolve => require(['@/components/basicData/subModule/vehicleTypeManagement/vehicleTypeDetails'], resolve)
var vehicleTypeListAdd = function vehicleTypeListAdd(resolve) {
  spinRoute.show();
  require(['@/components/basicData/subModule/vehicleTypeManagement/vehicleTypeListAdd'], spinRoute.resolve(resolve));
};

//成功路由
var success = function success(resolve) {
  spinRoute.show();
  require(['@/components/pages/success.vue'], spinRoute.resolve(resolve));
};

//评审文件列表
var reviewList = function reviewList(resolve) {
  spinRoute.show();
  require(['@/components/bidding/reviewList/reviewList.vue'], spinRoute.resolve(resolve));
};
//旧评审文件列表详情
/* const reviewListDetail = resolve => {
  spinRoute.show();
  require(['@/components/bidding/reviewList/reviewListDetail.vue'], spinRoute.resolve(resolve))
}; */
//新评审文件列表详情
var reviewListDetail = function reviewListDetail(resolve) {
  spinRoute.show();
  require(['@/views/bidManageNew/reviewManageNew/detail.vue'], spinRoute.resolve(resolve));
};

//编制评审文件
var buildReview = function buildReview(resolve) {
  spinRoute.show();
  require(['@/components/bidding/reviewList/buildReview.vue'], spinRoute.resolve(resolve));
};

/**
 * 路由数组对象
 * meta字段对应
 * authe:该路由是否token验证
 * title:标签页显示的名称，后期可弄成国际化
 * affix:固钉 标签页固定的标签
 * @type {*[]}
 */
export var asyncRoutes = [{
  path: '/',
  name: 'loginApp',
  component: loginApp
}, {
  path: '/wz/singleAuthentication',
  name: 'wzSingleAuthentication',
  component: wzSingleAuthentication
}, {
  path: '/singleAuthentication',
  name: 'singleAuthentication',
  component: singleAuthentication
}, {
  path: '/main',
  name: 'mainApp',
  meta: {
    authe: true
  },
  component: mainApp,
  children: [].concat(_toConsumableArray(routers), [{
    path: 'dataScreening',
    //基础资料
    name: 'dataScreening',
    component: dataScreening,
    meta: {
      authe: true,
      title: "首页",
      affix: true
    }
  }, {
    path: 'international/dataScreening',
    //基础资料
    name: 'international/dataScreening',
    component: internationalDataScreening,
    meta: {
      authe: true,
      title: "首页",
      affix: true
    }
  }, {
    path: 'basicData',
    //基础资料
    name: 'basicData',
    component: basicData,
    meta: {
      authe: true,
      affix: true
    }
  }, {
    path: 'treeDeptList',
    //树状结构
    name: 'treeDeptList',
    component: treeDeptList,
    meta: {
      authe: true
    },
    children: [{
      path: 'treeDeptDetails',
      //部门树状详情
      name: 'treeDeptList/treeDeptDetails',
      component: treeDeptDetails,
      meta: {
        authe: true,
        title: "公司管理"
      }
    }]
  }, {
    path: 'deptAdd',
    //部门编制
    name: 'deptAdd',
    component: deptAdd,
    meta: {
      authe: true,
      title: "部门编制"
    }
  }, {
    path: 'deptList',
    //部门列表
    name: 'deptList',
    component: deptList,
    meta: {
      authe: true
    },
    children: [{
      path: 'deptDetails',
      //部门详情
      name: 'deptList/deptDetails',
      component: deptDetails,
      meta: {
        authe: true,
        title: "部门管理"
      }
    }]
  }, {
    path: "employeeListAdd",
    //编制员工
    name: 'employeeListAdd',
    component: employeeListAdd,
    meta: {
      authe: true,
      title: "编制员工"
    }
  }, {
    path: 'employeeList',
    //员工列表
    name: 'employeeList',
    component: employeeList,
    meta: {
      authe: true
    },
    children: [{
      path: 'employeeDetails',
      //员工详情
      name: 'employeeList/employeeDetails',
      component: employeeDetails,
      meta: {
        authe: true,
        title: "员工管理"
      }
    }]
  }, {
    path: 'employeeDetails',
    //员工详情
    name: 'employeeDetails',
    component: employeeListDetails,
    meta: {
      authe: true,
      title: "员工详情"
    }
  }, {
    path: 'permissionManagement',
    //权限管理
    name: 'permissionManagement',
    component: permissionManagement,
    meta: {
      authe: true,
      title: "权限管理"
    }
  }, {
    path: 'roleListAdd',
    //编制角色
    name: 'roleListAdd',
    component: roleListAdd,
    meta: {
      authe: true,
      title: "编制角色"
    }
  }, {
    path: 'roleList',
    //角色列表
    name: 'roleList',
    component: roleList,
    meta: {
      authe: true,
      title: "角色列表"
    }
  }, {
    path: 'roleDetails',
    //角色详情
    name: 'roleDetails',
    component: roleDetails,
    hidden: true,
    meta: {
      authe: true,
      title: "角色详情"
    }
  }, {
    path: 'auditEmpList',
    //审批人员列表
    name: 'auditEmpList',
    component: auditEmpList,
    meta: {
      authe: true,
      title: "审批人员列表"
    }
  }, {
    path: 'vehicleMap',
    //车辆分布地图
    name: 'vehicleMap',
    component: vehicleMap,
    meta: {
      authe: true,
      title: "车辆分布地图"
    }
  }, {
    path: 'vehicleMainDetailMap',
    //设备轨迹
    name: 'vehicleMainDetailMap',
    component: vehicleMainDetailMap,
    hidden: true,
    meta: {
      authe: true,
      title: "车辆轨迹"
    }
  }, {
    path: 'vehicleList',
    //设备列表
    name: 'vehicleList',
    component: vehicleList,
    meta: {
      authe: true,
      title: "车辆列表"
    }
  }, {
    path: 'terminal-list',
    //终端列表
    name: 'terminalList',
    component: function component() {
      return import('@/components/vehicle/subModule/terminalList');
    },
    meta: {
      authe: true,
      title: "终端列表"
    }
  }, {
    path: 'binding-records',
    //绑定记录
    name: 'bindingRecords',
    component: function component() {
      return import('@/components/vehicle/subModule/bindingRecords');
    },
    meta: {
      authe: true,
      title: "绑定记录"
    }
  }, {
    path: 'vehicle-data',
    //数据
    name: 'vehicleData',
    component: function component() {
      return import('@/components/vehicle/subModule/vehicleData');
    },
    meta: {
      authe: true,
      title: "数据"
    }
  }, {
    path: 'orderList',
    //机械调度统计
    name: 'orderList',
    component: orderList,
    meta: {
      authe: true,
      title: "机械调度统计"
    }
  }, {
    path: 'completedList',
    //完工单列表
    name: 'completedList',
    component: completedList,
    meta: {
      authe: true,
      title: "完工单列表"
    }
  }, {
    path: 'completedDetails',
    //完工单详情
    name: 'completedDetails',
    component: completedDetails,
    hidden: true,
    meta: {
      authe: true,
      title: "完工单详情"
    }
  }, {
    path: 'orderStatistics',
    //施工任务统计
    name: 'orderStatistics',
    component: orderStatistics,
    meta: {
      authe: true,
      title: "施工任务统计"
    }
  }, {
    path: 'orderStatisticsDetails',
    //施工任务统计详情
    name: 'orderStatisticsDetails',
    component: orderStatisticsDetails,
    hidden: true,
    meta: {
      authe: true,
      title: "施工任务统计详情"
    }
  }, {
    path: 'orderDetails',
    //机械调度详情
    name: 'orderDetails',
    component: orderDetails,
    hidden: true,
    meta: {
      authe: true,
      title: "机械调度详情"
    }
  }, {
    path: 'submitOrder',
    //下单
    name: 'submitOrder',
    component: submitOrder,
    meta: {
      authe: true,
      title: "下单"
    }
  }, {
    path: 'myOrderAuditList',
    //我的施工任务审核列表
    name: 'myOrderAuditList',
    component: myOrderAuditList,
    meta: {
      authe: true,
      title: "我的施工任务审核列表"
    }
  }, {
    path: 'myOrderAuditDetails',
    //我的施工任务审核详情
    name: 'myOrderAuditDetails',
    component: myOrderAuditDetails,
    hidden: true,
    meta: {
      authe: true,
      title: "我的施工任务审核详情"
    }
  }, {
    path: 'workOrderList',
    //工单列表
    name: 'workOrderList',
    component: workOrderList,
    meta: {
      authe: true,
      title: "机械使用确认单列表"
    }
  }, {
    path: 'equipmentUsedOrder',
    name: 'equipmentUsedOrder',
    component: function component() {
      return import('@/components/order/onSiteSign');
    },
    meta: {
      authe: true,
      title: '机械使用现场签认单'
    }
  }, {
    path: 'equipmentUsedOrder/create',
    name: 'onSiteSignAdd',
    component: function component() {
      return import('@/components/order/onSiteSign/add');
    },
    meta: {
      authe: true,
      title: '编制机械使用现场签认单'
    }
  }, {
    path: 'equipmentUsedOrder/details',
    name: 'onSiteSignCreate',
    component: function component() {
      return import('@/components/order/onSiteSign/detail');
    },
    meta: {
      authe: true,
      title: '机械使用现场签认单'
    }
  }, {
    path: 'arrivalConfirmList',
    //进场签认单列表
    name: 'arrivalConfirmList',
    component: function component() {
      return import('@/components/order/arrivalConfirm');
    },
    meta: {
      authe: true,
      title: "租赁设备进场签认单"
    }
  }, {
    path: 'arrivalConfirmAdd',
    //编制进场签认单
    name: 'arrivalConfirmAdd',
    component: function component() {
      return import('@/components/order/arrivalConfirm/add');
    },
    meta: {
      authe: true,
      title: "编制租赁设备进场签认单"
    }
  }, {
    path: 'arrivalConfirmDetail',
    //进场签认单详情
    name: 'arrivalConfirmDetail',
    component: function component() {
      return import('@/components/order/arrivalConfirm/detail');
    },
    meta: {
      authe: true,
      title: "租赁设备进场签认单详情"
    }
  }, {
    path: 'workOrderDetails',
    //工单详情
    name: 'workOrderDetails',
    component: workOrderDetails,
    hidden: true,
    meta: {
      authe: true,
      title: "工单详情"
    }
  }, {
    path: 'settleContractList',
    //合同工单列表
    name: 'settleContractList',
    component: settleContractList,
    meta: {
      authe: true,
      title: "合同工单列表"
    }
  }, {
    path: 'contractWorkOrderList',
    //合同工单
    name: 'contractWorkOrderList',
    component: contractWorkOrderList,
    meta: {
      authe: true,
      title: "合同工单"
    }
  }, {
    // 结算管理
    path: 'settle',
    name: 'settle',
    component: function component() {
      return import('@/components/settlementManage');
    },
    redirect: 'settle/leased-equip',
    meta: {
      authe: true,
      title: '结算管理'
    },
    children: [{
      path: 'leased-equip',
      name: 'settle/leased-equip',
      component: function component() {
        return import('@/components/settlementManage/leasedEquip');
      },
      meta: {
        authe: true,
        title: '租赁设备签认表'
      }
    }, {
      path: 'usageConfirmDetail',
      name: 'usageConfirmDetail',
      component: function component() {
        return import('@/components/settlementManage/leasedEquip/detail/usageConfirmDetail');
      },
      meta: {
        authe: true,
        title: '租赁设备使用签认表详情'
      }
    }, {
      path: 'usageConfirmItemDetail4Fixed',
      name: 'usageConfirmItemDetail4Fixed',
      component: function component() {
        return import('@/components/settlementManage/leasedEquip/detail/usageConfirmItemDetail4Fixed');
      },
      meta: {
        authe: true,
        title: '租赁设备使用明细表'
      }
    }, {
      path: 'usageConfirmItemDetail4Moved',
      name: 'usageConfirmItemDetail4Moved',
      component: function component() {
        return import('@/components/settlementManage/leasedEquip/detail/usageConfirmItemDetail4Moved');
      },
      meta: {
        authe: true,
        title: '租赁设备使用明细表'
      }
    }, {
      path: 'usageConfirmLaberDetail',
      name: 'usageConfirmLaberDetail',
      component: function component() {
        return import('@/components/settlementManage/leasedEquip/detail/usageConfirmLaberDetail');
      },
      meta: {
        authe: true,
        title: '租赁设备人工费签认表详情'
      }
    }, {
      path: 'settle-pay',
      name: 'settle/settle-pay',
      component: function component() {
        return import('@/components/settlementManage/settlePay');
      },
      meta: {
        authe: true,
        title: '结算支付汇总表'
      },
      children: []
    }, {
      path: 'pay-collect',
      name: 'payCollect',
      component: function component() {
        return import('@/components/settlementManage/settlePay/detail/PayCollect');
      },
      meta: {
        authe: true,
        title: '结算支付汇总表详情'
      }
    }, {
      path: 'create-pay-collect',
      name: 'createPayCollect',
      component: function component() {
        return import('@/components/settlementManage/settlePay/detail/CreatePayCollect');
      },
      meta: {
        authe: true,
        title: '编制结算支付汇总表'
      }
    }, {
      path: 'settle-param',
      name: 'settle-param',
      component: function component() {
        return import('@/components/settlementManage/settleParam');
      },
      meta: {
        authe: true,
        title: '结算台账'
      }
    }]
  }, {
    path: 'moveForm',
    //移动设备签认表
    name: 'moveForm',
    component: moveForm,
    meta: {
      authe: true,
      title: "移动设备签认表"
    }
  }, {
    path: 'moveFormDetail',
    //移动设备签认表详情
    name: 'moveFormDetail',
    component: moveFormDetail,
    hidden: true,
    meta: {
      authe: true,
      title: "移动设备签认表详情"
    }
  }, {
    path: 'fixedForm',
    //固定设备签认表
    name: 'fixedForm',
    component: fixedForm,
    meta: {
      authe: true,
      title: "固定设备签认表"
    }
  }, {
    path: 'fixedFormDetail',
    //固定设备签认表详情
    name: 'fixedFormDetail',
    component: fixedFormDetail,
    hidden: true,
    meta: {
      authe: true,
      title: "固定设备签认表详情"
    }
  }, {
    path: 'detailsForList',
    //明细表列表
    name: 'detailsForList',
    component: detailsForList,
    meta: {
      authe: true,
      title: "结算明细统计列表"
    }
  }, {
    path: 'detailsForListCreate',
    //明细表列表编制
    name: 'detailsForListCreate',
    component: detailsForListCreate,
    meta: {
      authe: true,
      title: "编制明细表列表"
    }
  }, {
    path: 'detailsForListDetail',
    //明细表列表编制
    name: 'detailsForListDetail',
    component: detailsForListDetail,
    hidden: true,
    meta: {
      authe: true,
      title: "明细表详情"
    }
  }, {
    path: 'summary',
    //汇总表列表
    name: 'summary',
    component: summary,
    meta: {
      authe: true,
      title: "结算汇总表统计列表"
    }
  }, {
    path: 'summaryCreate',
    //汇总表编制
    name: 'summaryCreate',
    component: summaryCreate,
    meta: {
      authe: true,
      title: "编制汇总表"
    }
  }, {
    path: 'summaryDetail',
    //汇总表编制
    name: 'summaryDetail',
    component: summaryDetail,
    hidden: true,
    meta: {
      authe: true,
      title: "汇总表详情"
    }
  }, {
    path: 'settleDetails',
    //生成结算
    name: 'settleDetails',
    component: settleDetails,
    hidden: true,
    meta: {
      authe: true,
      title: "结算详情"
    }
  }, {
    path: 'quantitativeSettle',
    //按量结算明细
    name: 'quantitativeSettle',
    component: quantitativeSettle,
    meta: {
      authe: true,
      title: "按量结算明细"
    }
  }, {
    path: 'contractEntry',
    //合同编制
    name: 'contractEntry',
    component: contractEntry,
    meta: {
      authe: true,
      title: "合同编制"
    }
  }, {
    path: 'contractList',
    //合同列表
    name: 'contractList',
    component: contractList,
    meta: {
      authe: true,
      title: "合同列表"
    }
  }, {
    path: 'contractListDetails',
    //合同列表详情
    name: 'contractListDetails',
    component: contractListDetails,
    hidden: true,
    meta: {
      authe: true,
      title: "合同列表详情"
    }
  }, {
    path: 'contractChangeList',
    //合同变更
    name: 'contractChangeList',
    component: contractChangeList,
    meta: {
      authe: true,
      title: "合同变更"
    }
  }, {
    path: 'contractChangeDetails',
    //合同变更详情
    name: 'contractChangeDetails',
    component: contractChangeDetails,
    hidden: true,
    meta: {
      authe: true,
      title: "合同变更详情"
    }
  }, {
    path: 'contractActivationList',
    //合同激活列表
    name: 'contractActivationList',
    component: contractActivationList,
    meta: {
      authe: true,
      title: "合同激活列表"
    }
  }, {
    path: 'contractActivationDetails',
    //合同激活详情
    name: 'contractActivationDetails',
    component: contractActivationDetails,
    hidden: true,
    meta: {
      authe: true,
      title: "合同激活详情"
    }
  }, {
    path: 'contractDone',
    //合同完善
    name: 'contractDone',
    component: contractDone,
    meta: {
      authe: true,
      title: "合同完善"
    }
  }, {
    path: 'contractReport',
    //合同台账
    name: 'contractReport',
    component: contractReport,
    meta: {
      authe: true,
      title: "合同台账"
    }
  }, {
    path: 'contractDoneDetails',
    //合同完善详情
    name: 'contractDoneDetails',
    component: contractDoneDetails,
    hidden: true,
    meta: {
      authe: true,
      title: "合同完善详情"
    }
  }, {
    path: 'contractEdit',
    //合同完善详情
    name: 'contractEdit',
    component: function component() {
      return import('@/components/contract/subModule/contractEdit');
    }
  }, {
    path: 'saveContractSuccess',
    //合同完善详情
    name: 'saveContractSuccess',
    component: function component() {
      return import('@/components/contract/subModule/success');
    }
  }, {
    path: 'contractDelayEdit',
    //合同完善详情
    name: 'contractDelayEdit',
    component: function component() {
      return import('@/components/contract/subModule/contractList/contractDelayEdit');
    }
  }, {
    path: 'experts',
    //专家列表
    name: 'experts',
    component: experts,
    meta: {
      authe: true,
      title: "专家列表"
    }
  }, {
    path: 'vehicleDetailsForVehicle',
    //设备下 设备详情
    name: 'vehicleDetailsForVehicle',
    component: vehicleDetailsForVehicle,
    hidden: true,
    meta: {
      authe: true,
      title: "设备详情"
    }
  }, {
    path: "examination",
    //资格审查
    name: 'examination',
    component: examination,
    meta: {
      authe: true,
      title: "资格审查"
    }
  }, {
    path: "examinationDetail",
    //资格审查详情
    name: 'examinationDetail',
    component: examinationDetail,
    hidden: true,
    meta: {
      authe: true,
      title: "资格审查详情"
    }
  }, {
    path: "blackmailAudit",
    //资格审查详情
    name: 'blackmailAudit',
    component: blackmailAudit,
    hidden: true,
    meta: {
      authe: true,
      title: "拉黑/恢复审核"
    }
  }, {
    path: "blackmailAuditList",
    //资格审查详情
    name: 'blackmailAuditList',
    component: blackmailAuditList,
    hidden: true,
    meta: {
      authe: true,
      title: "操作记录"
    }
  }, {
    path: 'supplier',
    //设备出租单位
    name: 'supplier',
    component: supplier,
    meta: {
      authe: true,
      title: "合格出租单位管理"
    }
  }, {
    path: "qualifiedSuppliersDetails",
    name: 'qualifiedSuppliersDetails',
    component: qualifiedSuppliersDetails,
    hidden: true,
    meta: {
      authe: true,
      title: "合格出租单位详情"
    }
  }, {
    path: "employeeInfo",
    name: 'employeeInfo',
    component: function component() {
      return import('@/components/qualifiedSupplierManagement/employeeInfo');
    },
    hidden: true
  }, {
    path: "vehicleInfo",
    name: 'vehicleInfo',
    component: function component() {
      return import('@/components/qualifiedSupplierManagement/vehicleInfo');
    },
    hidden: true
  }, {
    path: 'buildBidding',
    //询比价立项
    name: 'buildBidding',
    component: buildBidding,
    meta: {
      title: "询比价立项"
    }
  }, {
    path: 'reBuildBidding',
    //待询比价立项
    name: 'reBuildBidding',
    component: reBuildBidding,
    hidden: true,
    meta: {
      authe: true,
      title: "重新立项"
    }
  }, {
    path: 'updateBidding',
    //立项文件列表
    name: 'updateBidding',
    component: updateBidding,
    meta: {
      authe: true,
      title: "立项文件列表"
    }
  }, {
    path: 'bidReport',
    //租赁报表
    name: 'bidReport',
    component: bidReport,
    meta: {
      authe: true,
      title: "租赁报表"
    }
  }, {
    path: 'saveReport',
    //租赁报表
    name: 'saveReport',
    component: function component() {
      return import('@/components/bidding/bidReport/saveReport');
    },
    meta: {
      authe: true,
      title: '租赁节资率报表'
    }
  }, {
    path: 'rentReport',
    //租赁报表
    name: 'rentReport',
    component: function component() {
      return import('@/components/bidding/bidReport/rentReport');
    },
    meta: {
      authe: true,
      title: '租赁费用明细报表'
    }
  }, {
    path: 'rentPriceReport',
    //租赁报表
    name: 'rentPriceReport',
    component: function component() {
      return import('@/components/bidding/bidReport/rentPriceReport');
    },
    meta: {
      authe: true,
      title: '租赁费用明细报表'
    }
  }, {
    path: 'rentAppraisalReport',
    //租赁后评价报表
    name: 'rentAppraisalReport',
    component: function component() {
      return import('@/components/bidding/bidReport/rentAppraisalReport');
    },
    meta: {
      authe: true,
      title: '租赁后评价报表'
    }
  }, {
    path: 'rentOutReport',
    //设备租入(租出)清查登记表
    name: 'rentOutReport',
    component: function component() {
      return import('@/components/bidding/bidReport/rentOutReport');
    },
    meta: {
      authe: true,
      title: '设备租入(租出)清查登记表'
    }
  }, {
    path: 'offlineRentOutRecord',
    name: 'offlineRentOutRecord',
    component: function component() {
      return import('@/components/bidding/bidReport/offlineRentOutRecord');
    },
    meta: {
      authe: true,
      title: '线下租赁备案报表'
    }
  }, {
    path: 'offlineRentOutRecordAdd',
    name: 'offlineRentOutRecordAdd',
    component: function component() {
      return import('@/components/bidding/bidReport/offlineRentOutRecord/add');
    },
    meta: {
      authe: true,
      title: '编制线下租赁备案表'
    }
  }, {
    path: 'customReport',
    name: 'customReport',
    component: function component() {
      return import('@/components/bidding/bidReport/customReport');
    },
    meta: {
      authe: true,
      title: '设备租赁自定义报表'
    }
  }, {
    path: 'settlementsSummary',
    name: 'settlementsSummary',
    component: function component() {
      return import('@/components/bidding/bidReport/settlementsReport/settlementsList');
    },
    meta: {
      authe: true,
      title: '设备租赁自定义报表'
    }
  }, {
    path: 'settlementsReport',
    //设备租入(租出)清查登记表
    name: 'settlementsReport',
    component: function component() {
      return import('@/components/bidding/bidReport/settlementsReport');
    },
    meta: {
      authe: true,
      title: '设备租赁管理月/季度报表'
    }
  }, {
    path: 'settlementsReportAdd',
    //设备租入(租出)清查登记表
    name: 'settlementsReportAdd',
    component: function component() {
      return import('@/components/bidding/bidReport/settlementsReport/add');
    },
    meta: {
      authe: true,
      title: '设备租赁管理月/季度报表'
    }
  }, {
    path: 'bidFilesListSuccess',
    //设备租入(租出)清查登记表
    name: 'bidFilesListSuccess',
    component: function component() {
      return import('@/views/bidManageNew/bidFilesListNew/success');
    }
  }, {
    path: 'updateBiddingDetail',
    //修改标书详情
    name: 'updateBiddingDetail',
    component: updateBiddingDetail,
    hidden: true,
    meta: {
      authe: true,
      title: "标书详情"
    }
  }, {
    path: "errorSession",
    //登陆已过期
    name: "errorSession",
    component: errorSession,
    hidden: true,
    meta: {
      authe: true
    }
  }, {
    path: "personalSafe",
    //安全中心
    name: "personalSafe",
    component: personalSafe,
    meta: {
      authe: true,
      title: "安全中心"
    }
  }, {
    path: "personalCenter",
    //个人中心
    name: "personalCenter",
    component: personalCenter,
    meta: {
      authe: true,
      title: "个人中心"
    }
  }, {
    path: "messageInfo",
    //推送消息通知
    name: "messageInfo",
    component: messageInfo,
    meta: {
      authe: true,
      title: "推送消息通知"
    }
  }, {
    path: "todoList",
    //推送待办事项
    name: "todoList",
    component: todoList,
    meta: {
      authe: true,
      title: "推送待办事项"
    }
  }, {
    path: "carManagement",
    //车辆年审管理首页
    name: "carManagement",
    component: carManagement,
    meta: {
      authe: true,
      title: "车辆年审管理首页"
    }
  }, {
    path: "vehicleNetApp",
    //设备物联网首页
    name: "vehicleNetApp",
    component: vehicleNetApp,
    meta: {
      authe: true,
      title: "设备物联管理首页"
    }
  }, {
    path: "bidModel",
    //租赁管理首页
    name: "bidModel",
    component: bidModel,
    meta: {
      authe: true,
      title: "租赁管理首页"
    }
  }, {
    path: "reviewList",
    //评审文件管理
    name: "reviewList",
    component: reviewList,
    meta: {
      authe: true,
      title: "评审文件管理"
    }
  }, {
    path: "reviewListDetail",
    //评审文件列表详情
    name: "reviewListDetail",
    component: reviewListDetail,
    hidden: true,
    meta: {
      authe: true,
      title: "评审文件列表详情"
    }
  }, {
    path: 'success',
    //成功页面
    name: 'success',
    component: success,
    hidden: true,
    meta: {
      authe: true,
      title: "成功"
    }
  }, {
    path: "*",
    component: waiting
  }])
}, {
  path: "*",
  redirect: "/"
}];
export default new VueRouter({
  routes: asyncRoutes
});